import { Component, inject, output } from '@angular/core';
import { GaService } from '@/app/services/ga/ga';

@Component({
  selector: 'v2-route-select',
  imports: [],
  templateUrl: './route-select.html',
  styleUrl: './route-select.css',
})
export class RouteSelectComponent {

  routeSelected = output<string>();

  /** Services */
  private gaService = inject(GaService);
  /** Services - END */

  onSpeedySelect() {
    console.log('Speedy Setup selected');
    this.gaService.trackOnboardingEvent('onboarding_quick_brief');
    this.routeSelected.emit('speedy');
  }

  onInDepthSelect() {
    console.log('In-depth route — Skip brief creation in wizard');
    this.gaService.trackOnboardingEvent('onboarding_skip_brief');
    this.routeSelected.emit('in-depth');
  }
}
